export const translations = {
  en: {
    homePage: 'Home Page',
    news: 'News',
    festival: 'Festival',
    specialty: 'Specialty',
    location: 'Location',
    schedule: 'Destination',
    restaurant: 'Restaurant',
    hotel: 'Hotel',
    signIn: 'Sign In',
    register: 'Sign Up',
    logOut: 'Log Out',
    english: 'English',
    vietnamese: 'Vietnamese',
    wellcome: 'Wellcome to',
    daknong: 'Dak Nong',
    wellcomeText:
      'Enjoy every moment of your trip. A trip is not just a transition but an action experience',
    exploreNow: 'Explore Now',
    viewMore: 'View More',
    exploreTravel: 'Explore Dak Nong Tourism',
    mostProminent: 'The most prominent types of tourism',
    pdfMap: 'PFD Maps',
    downloadApp: 'Dowload App',

    //////

    //////
    cityTravel: 'City travel',
    nature: 'Nature',
    //////

    destination: 'Destination',
    todayNews: `Update news every day`,
    exploreCuisine: 'Explore Cuisine',
    traditionalFestival: 'Traditional Festival',
    //////
    //////
    destinationDes: 'Explore new tourist destinations',
    todayNewsDes: 'Read the latest articles and news',
    exploreCuisineDes: 'Explore the rich cuisine in this land',
    traditionalFestivalDes: 'Learn about traditional festivals',
    //////
    readyFor: 'Be ready for those',
    experienceTravel: 'New travel experience',
    experienceThese: 'Experience these',
    specialtyOf: 'specialty of',
    ////
    footerInfo:
      'Come to Dak Nong To have truly memorable travel experiences Dak Nong, a wonderful land!',
    map: 'Map',
    listmap: 'List Map',
    contactInfo: 'Contact Information',
    address: 'Address',
    phone: 'Phone Number',
    chooseSchedule: 'Explore interesting tourist destinations',

    restaurantSlogan: 'Enjoy the culinary spaces',
    hotelSlogan: 'Luxurious resting space',
    festivalSlogan: 'The cultural beauty of this land',
    specialtySlogan: 'Experience culinary culture',

    detail: 'Information Detail',
    geographicalLocation: 'Geographical location',
    directions: 'Directions',
    relatedNews: 'Related news',
    ////
    ////
    info: 'Info',
    gallery: 'Gallery',
    policy: 'Policy',
    type: 'Type of tourism',
    price: 'Price',
    openTime: 'Opening times',
    closeTime: 'Close times',
    view: 'Views',
    serviceAttentive: 'Services for attentive asistance',
    transportation: 'Transportation services',
    makeReservation: 'Make a reservation',
    relatedSchedule: 'Related destination',
    ////

    ////
    specialtyName: 'Specialty Name',
    festivalName: 'Festival Name',
    restaurantName: 'Restaurant Name',
    hotelName: 'Hotel Name',

    ////

    ////
    enterEmail: 'Enter Email',
    enterPassword: 'Enter Password',
    enterFirstName: 'Enter FirstName',
    enterLastName: 'Enter LastName',
    enterPhoneNumber: 'Enter PhoneNumber',
    enterAddress: 'Enter Address',
    notAccount: 'You have not created an account',
    alreadyAcount: 'You already have an account',
    logOutConfirm: 'Do you want to log out of the system',
    cancel: 'Cancel',
    correctFormat: 'Please enter the correct format',
    pleaseEnter: 'Please enter',

    email: 'Email',
    password: 'Password',
    firstName: 'FirstName',
    lastName: 'LastName',
    phoneNumber: 'PhoneNumber',
    address: 'Address',

    enterMissingInformation: 'Enter missing information',
    pleaseEnterCompleteInformation: 'Please enter complete information',
    ////
    ////
    nameTour: 'Name Destination',
    enterName: 'Enter Name',
    district: 'District',
    nameFestival: 'Name Festival',
    startDate: 'Start date',
    endDate: 'End Date',
    nameSpecialty: 'Name Specialty',
    nameNews: 'Name News',
    postingDate: 'Posting Date',
    category: 'Category',
    sortBy: 'Sort By',
    latestPost: 'Latest post',
    longestPost: 'Longest post',
    ////

    ////
    travelDiscover: 'Travel discover',
    ecoTourism: 'Ecotourism',
    commerceCuisine: 'Commerce-Cuisine',
    leisureTravel: 'Leisure Travel',
    structures: 'Structures',
    spiritualTourism: 'Spiritual Tourism',
    logOutSuccess: 'Signed Out Successfully',
    logOutMessage: 'You have logged out of the system',
    ////
    free: 'Free',
    noDestination: 'There has been no service recently',
    destinatioService: 'Service location',
    noVideo: 'No Video',
    noGallery: 'No Gallery',

    // Map ////////
    searchKeyWord: 'Enter keywords to search',

    listOfBasemaps: 'List of Basemaps',
    touristAttraction: 'Tourist Aattraction',
    accommodationPoint: 'Accommodation Point',
    cuisine: 'Cuisine',
    rentService: 'Rent Service',
    viewSatelliteImages: 'View satellite images',
    needSeeSatellite: 'You need to see satellite images in over',
    aPeriodOfTime: 'a period of time.',
    photoType: 'Photo type',
    cloudCover: 'Cloud cover',
    enterCloudCover: 'Enter cloud cover (Default 100)',
    viewPhoto: 'View Photo',
    suggestedSchedule: 'Suggested schedule',
    numberDestination: 'Number of destination',
    dest: 'Dest',
    endSchedule: 'End of schedule',
    searchRestaurants: 'Search by restaurants',
    searchDestination: 'Search by destination',
    searchAccommodationPoint: 'Search by accommodation point',
    searchDistance: 'Search by distance',
    searchBK: 'Enter the distance (km) you want to search for',

    // Map ////////
    satelliteImageMapOfDakNong: 'Satellite image map of Dak Nong',
    bandoPDF: 'PDF Maps',
    dakNongOverlayMap:
      'Map of current surface cover status in Dak Nong province in 2022',
    mapOfTouristAttractionsInDakNongProvince:
      'Map of tourist flow in Dak Nong province',
    dakNongProvinceTouristRouteMap:
      'Map of tourist routes of Dak Nong province',
    bando: 'Map of tourist attractions in Dak Nong province',
    naturalTourismResourcesMapOfDakNongProvince:
      'Map of natural tourism resources of Dak Nong province',
    culturalTourismResourcesMapOfDakNongProvince:
      'Map of cultural tourism resources of Dak Nong province',
    mapOfNaturalTourismResourcesOfTheProvinceDakNong:
      'Map of technical conditions for tourism in Dak Nong province',
    tourismAtlasOfDakNongProvince: 'Tourism Atlas of Dak Nong province',
    anhvetinhlopphu: 'Overlay satellite image',
    /////

    touristRouteMap: 'Tourist route map',
    touristRoutes: ' Tourist routes',
    natureReserve: 'Nature reserve',
    nationalParks: 'National Parks',
    geologicalCave: 'Geological cave',
    river: 'River',
    waterfall: 'Waterfall',
    lake: 'Lake',
    isLand: 'IsLand',
    volcano: 'Volcano',
    other: 'Other',

    pagoda: 'Pagoda',
    historicalSites: 'Historical Sites',
    monument: 'Monument',

    market: 'Market',
    hospital: 'Hospital',
    bank: 'Bank',
    supermarketsTradeCenters: 'Supermarkets, trade centers',
    hotel: 'Hotel',
    guestHouse: 'Guest house',
    budgetMotel: 'Budget motel',
    restaurant: 'Restaurant',
    eatery: 'Eatery',
    cinema: 'Cinema',
    domesticCirculationCompany: 'Domestic circulation company',
    otherAccommodationFacilities: 'Other accommodation facilities',
    satelliteImage: 'Satellite image',
    lopLuongMua: 'Precipitation class',
    tourismFacilities: 'Tourism facilities',
    naturalTourismResources: 'Natural tourism resources',
    culturalTourismResources: 'Cultural tourism resources',
    touristFlow: 'Tourist flow',
    touristFlowChart: 'Tourist flow chart',
    locationC: 'Loation C',
    museumsGalleries: 'Museums, galleries',
    monastery: 'Monastery',
    farm: 'Farm',
    abbey: 'Abbey',
    park: 'Park',
    riverStream: 'River, Stream',
    touristArea: 'Tourist area',
    attractiveTouristDestinationArea: 'Attractive tourist destination area',
    addressDN: '23/3 street Gia Nghia, Dak Nong'
  },
  vi: {
    homePage: 'Trang chủ',
    news: 'Tin tức',
    festival: 'Lễ hội',
    specialty: 'Đặc sản',
    location: 'Địa điểm',
    schedule: 'Điểm du lịch',
    restaurant: 'Nhà hàng',
    hotel: 'Khách sạn',
    signIn: 'Đăng nhập',
    register: 'Đăng kí',
    logOut: 'Đăng xuất',
    english: 'Tiếng Anh',
    vietnamese: 'Tiếng Việt',
    wellcome: 'Chào mừng đến với',
    daknong: 'Đắk Nông',
    wellcomeText:
      'Tận hưởng mọi khoảnh khắc của chuyến đi của bạn. Một chuyến đi không chỉ là sự di chuyển, đó là một hành trình trải nghiệm',
    exploreNow: 'Khám phá ngay',
    viewMore: 'Xem thêm',
    exploreTravel: 'Khám phá du lịch Đắk Nông',
    mostProminent: 'Những loại hình du lịch nổi bật nhất',
    pdfMap: 'Bản đồ PFD',
    downloadApp: 'Tải App',

    //////
    destination: 'Địa điểm du lịch',
    todayNews: `Cập nhật tin tức mỗi ngày`,
    exploreCuisine: 'Khám phá ẩm thực',
    traditionalFestival: 'Lễ hội truyền thống',
    //////
    //////
    destinationDes: 'Khám phá những địa điểm du lịch mới',
    todayNewsDes: 'Đọc những bài viết, tin tức mới nhất',
    exploreCuisineDes: 'Khám phá ẩm thực phong phú tại đây',
    traditionalFestivalDes: 'Tìm hiểu các lễ hội truyền thống',
    //////
    readyFor: 'Sẵn sáng cho những',
    experienceTravel: 'Trải nghiệm du lịch mới',
    experienceThese: 'Trải nghiệm những',
    specialtyOf: 'đặc sản của',
    ////
    footerInfo:
      'Hãy đến với Đắk Nông Để có những trải nghiệm du lich thực sự đáng nhớ Đắk Nông, vùng đất tuyệt vời !',
    map: 'Bản đồ',
    listmap: 'Các bản đồ khác',
    contactInfo: 'Thông tin liên hệ',
    address: 'Địa chỉ',
    phone: 'SĐT Liên hệ',
    chooseSchedule: 'Khám phá những địa điểm du lịch thú vị',
    restaurantSlogan: 'Tận hưởng những không gian ẩm thực',
    hotelSlogan: 'Không gian nghỉ ngơi sang trọng',
    festivalSlogan: 'Những nét đẹp văn hóa của vùng đất này',
    specialtySlogan: 'Trải nghiệm văn hóa ẩm thực',

    detail: 'Thông tin chi tiết',
    geographicalLocation: 'Vị trí địa lý',
    directions: 'Chỉ dẫn đường đi',
    relatedNews: 'Tin tức liên quan',
    ////
    ////
    info: 'Thông tin',
    gallery: 'Ảnh',
    policy: 'Điều khoản',
    type: 'Loại hình du lịch',
    price: 'Giá vé',
    openTime: 'Giờ mở cửa',
    closeTime: 'Giờ đóng cửa',
    view: 'Lượt xem',
    serviceAttentive: 'Dịch vụ hỗ trợ tận tình',
    transportation: 'Dịch vụ di chuyển',
    makeReservation: 'Đặt lịch trình',
    relatedSchedule: 'Địa điểm liên quan',
    ////

    ////
    specialtyName: 'Tên đặc sản',
    festivalName: 'Tên lễ hội',
    restaurantName: 'Tên nhà hàng',
    hotelName: 'Tên khách sạn',
    ////

    ////
    enterEmail: 'Nhập Email',
    enterPassword: 'Nhập Mật khẩu',
    enterFirstName: 'Nhập Tên',
    enterLastName: 'Nhập Họ',
    enterPhoneNumber: 'Nhập SĐT',
    enterAddress: 'Nhập Địa chỉ',
    notAccount: 'Bạn chưa có tài khoản',
    alreadyAcount: 'Bạn đã có tài khoản',
    logOutConfirm: 'Bạn có muốn đăng xuất khỏi hệ thống',
    cancel: 'Hủy',
    correctFormat: 'Vui lòng nhập đúng định dạng',
    pleaseEnter: 'Vui lòng nhập',

    email: 'Email',
    password: 'Mật khẩu',
    firstName: 'Tên',
    lastName: 'Họ',
    phoneNumber: 'SĐT',

    enterMissingInformation: 'Nhập thiếu thông tin',
    pleaseEnterCompleteInformation: 'Vui lòng nhập đầy đủ thông tin',
    ////
    ////
    nameTour: 'Tên địa điểm',
    enterName: 'Nhập tên',
    district: 'TP/Huyện',
    nameFestival: 'Tên Lễ hội',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    nameSpecialty: 'Tên đặc sản',
    nameNews: 'Tên tin tức',
    postingDate: 'Ngày đăng bài',
    category: 'Danh mục',
    sortBy: 'Sắp xếp',
    latestPost: 'Bài đăng mới nhất',
    longestPost: 'Bài đăng lâu nhất',
    ////

    ////
    travelDiscover: 'Du lịch khám phá',
    ecoTourism: 'Du lịch sinh thái',
    commerceCuisine: 'Thương mại - ẩm thực',
    leisureTravel: 'Du lịch giải trí',
    structures: 'Công trình-Kiến trúc',
    spiritualTourism: 'Du lịch tâm linh',
    logOutSuccess: 'Đăng xuất thành công',
    logOutMessage: 'Bạn đã đăng xuất khỏi hệ thống',
    ////
    free: 'Miễn phí',
    noDestination: 'Không có dịch vụ nào gần đây',
    destinatioService: 'Địa điểm cung cấp dịch vụ',
    noVideo: 'Chưa có video',
    noGallery: 'Chưa có danh sách ảnh',

    // Map ////////
    searchKeyWord: 'Nhập từ khoá để tìm kiếm',

    listOfBasemaps: 'Danh sách bản đồ nền',
    touristAttraction: 'Địa điểm du lịch',
    accommodationPoint: 'Lưu trú',
    cuisine: 'Ẩm thực',
    rentService: 'Dịch vụ thuê xe',
    viewSatelliteImages: 'Xem ảnh vệ tinh',
    needSeeSatellite: 'Bạn cần xem ảnh vệ tinh trong',
    aPeriodOfTime: '1 khoảng thời gian.',
    photoType: 'Loại ảnh',
    cloudCover: 'Độ phủ mây',
    enterCloudCover: 'Nhập độ phủ mây (Mặc định 100)',
    viewPhoto: 'Xem ảnh',
    suggestedSchedule: 'Gợi ý lịch trình',
    numberDestination: 'Số địa điểm',
    dest: 'Điểm',
    endSchedule: 'Kết thúc lịch trình',
    searchRestaurants: 'Tìm kiếm nhà hàng',
    searchDestination: 'Tìm kiếm địa điểm du lịch',
    searchAccommodationPoint: 'Tìm kiếm địa điểm lưu trú',
    searchDistance: 'Tìm kiếm địa điểm theo khoảng cách',
    searchBK: 'Nhập khoảng cách (km) muốn tìm kiếm',

    // Map ////////

    satelliteImageMapOfDakNong: 'Bản đồ Ảnh vệ tinh',
    bandoPDF: 'Bản đồ PDF',

    dakNongOverlayMap:
      'Bản đồ hiện trạng lớp phủ bề mặt tỉnh Đắk Nông năm 2022',
    mapOfTouristAttractionsInDakNongProvince:
      'Bản đồ luồng khách du lịch tỉnh Đắk Nông',
    dakNongProvinceTouristRouteMap: 'Bản đồ tuyến du lịch tỉnh Đắk Nông',
    bando: 'Bản đồ điểm du lịch tỉnh Đắk Nông',
    naturalTourismResourcesMapOfDakNongProvince:
      'Bản đồ tài nguyên du lịch tự nhiên tỉnh Đắk Nông',
    culturalTourismResourcesMapOfDakNongProvince:
      'Bản đồ tài nguyên du lịch văn hóa tỉnh Đắk Nông',
    mapOfNaturalTourismResourcesOfTheProvinceDakNong:
      'Bản đồ điều kiện kỹ thuật du lịch tỉnh Đắk Nông',
    tourismAtlasOfDakNongProvince: 'Atlas du lịch tỉnh Đắk Nông',
    anhvetinhlopphu: 'Ảnh lớp phủ',
    /////////////////
    touristRouteMap: 'Bản đồ tuyến du lịch',
    touristRoutes: 'Tuyến du lịch',

    natureReserve: 'Khu bảo tồn thiên nhiên',
    nationalParks: 'Vườn quốc gia',
    geologicalCave: 'Hang động địa chất',
    river: 'Sông',
    waterfall: 'Thác',
    lake: 'Hồ',
    isLand: 'Đảo',
    volcano: 'Núi lửa',
    other: 'Khác',

    pagoda: 'Chùa',
    historicalSites: 'Di tích lịch sử',
    monument: 'Tượng đài',

    market: 'Chợ',
    hospital: 'Bệnh viện',
    bank: 'Ngân hàng',
    supermarketsTradeCenters: 'Siêu thị, trung tâm thương mại',
    hotel: 'Khách sạn',
    guestHouse: 'Nhà khách',
    budgetMotel: 'Nhà nghỉ',
    restaurant: 'Nhà hàng',
    eatery: 'Quán ăn',
    cinema: 'Rạp chiếu phim',
    domesticCirculationCompany: 'Cty lưu hành nội địa',
    otherAccommodationFacilities: 'Cơ sở lưu trú khác',
    satelliteImage: 'Ảnh vệ tinh',
    lopLuongMua: 'Lớp lượng mưa',
    tourismFacilities: 'Cơ sở vật chất du lịch',
    naturalTourismResources: 'Tài nguyên du lịch tự nhiên',
    culturalTourismResources: 'Tài nguyên du lịch văn hoá',
    touristFlow: 'Luồng khách du lịch',
    touristFlowChart: 'Biểu đồ luồng khách du lịch',
    locationC: 'Điểm C',
    museumsGalleries: 'Bảo tàng, nhà trưng bày',
    monastery: 'Thiền viện',
    farm: 'Trang trại',
    abbey: 'Tu viện',
    park: 'Công viên',
    riverStream: 'Sông, Suối',
    touristArea: 'Khu du lịch',
    attractiveTouristDestinationArea: 'Vùng điểm du lịch hấp dẫn',
    addressDN: 'Đường 23/3, TP.Gia Nghĩa,Đắk Nông'
  }
  // Thêm các ngôn ngữ khác nếu cần
}
